import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetAllEmpresas = ()  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/empresas`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAllEmpresasMutation: mutation.mutate,
    };
}